import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <g fill={colorValue} clipPath="url(#clip0_4455_1013)">
        <path d="M15.53 8.47a.75.75 0 0 1 0 1.06L13.06 12l2.47 2.47a.75.75 0 1 1-1.06 1.06L12 13.06l-2.47 2.47a.75.75 0 0 1-1.06-1.06L10.94 12 8.47 9.53a.75.75 0 0 1 1.06-1.06L12 10.94l2.47-2.47a.75.75 0 0 1 1.06 0"></path>
        <path
          fillRule="evenodd"
          d="M7.744 2.47a.75.75 0 0 1 .53-.22h7.452a.75.75 0 0 1 .53.22l5.274 5.274c.141.14.22.331.22.53v7.452a.75.75 0 0 1-.22.53l-5.274 5.274a.75.75 0 0 1-.53.22H8.274a.75.75 0 0 1-.53-.22L2.47 16.256a.75.75 0 0 1-.22-.53V8.274a.75.75 0 0 1 .22-.53zm.84 1.28L3.75 8.585v6.83l4.835 4.835h6.83l4.835-4.835v-6.83L15.415 3.75z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4455_1013">
          <path fill="transparent" d="M0 0h24v24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
